<template>
  <div>
    <v-navigation-drawer
      dark
      clipped
      :mini-variant="isMini"
      :mini-variant-width="miniMenuWidth"
      v-model="displayMenuModel"
      app
      :temporary="isSmartphoneMenu"
      mobile-breakpoint="960"
      width="300"
    >
      <v-card color="#1f8388" v-if="isSmartphoneMenu">
        <v-list-item v-if="!isAuthenticated" @click="login">
          <v-list-item-action>
            <v-icon>login</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Connexion</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
      <v-list>
        <div v-for="link in links" :key="link.name">
          <v-list-item :to="link.path" v-if="getLinkVisibility(link.meta)">
            <v-list-item-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>{{ link.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
        <FormulaireMenu />
      </v-list>

      <v-card
        v-show="this.displayedArrow()"
        class="hidden-sm-and-down moving-arrow"
        :style="arrowStyle"
      ></v-card>

      <!--<template v-slot:append>
        <div class="pa-2 text-center">
          <a href="https://www.univ-lille.fr" title="Université de Lille">
            <img :src="getLogoUrl(logo)" />
          </a>
        </div>
      </template>-->
      <template v-slot:append>
        <div class="pa-2 text-center link-donneesPersonnelles">
          <a :href="donneesPersonnellesUrl" title="Université de Lille">
            informations relatives à l'utilisation des données personnelles
          </a>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FormulaireMenu from "@/components/formulaire/Menu";

export default {
  name: "BaseMenu",
  components: {
    FormulaireMenu
  },
  props: { displayMenu: Boolean, isSmartphoneMenu: Boolean, isMini: Boolean },
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      // URL de connexion
      loginUrl:
        process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_LOGIN,
      donneesPersonnellesUrl:
        process.env.VUE_APP_HOST + "/donnees-personnelles",
      activeLinkIndex: 0,
      activeLink: null,
      linkHeight: 48,
      logo: "logo.png"
    };
  },
  computed: {
    ...mapState(["user", "isAuthenticated"]),

    displayMenuModel: {
      get() {
        return this.displayMenu;
      },
      set(value) {
        this.$emit("update:displayMenu", value);
      }
    },
    miniMenuWidth() {
      if (this.isSmartphoneMenu) {
        return 63;
      }
      return 55;
    },

    arrowStyle() {
      var arrowMovePx = this.linkHeight * this.findActiveLinkPosition();
      return {
        transform: `translate3d(0px, ${arrowMovePx}px, 0px)`
      };
    },

    links() {
      return this.$router.options.routes;
    }
  },
  mounted() {
    this.$watch("$route", this.findActiveLink, {
      immediate: true
    });

    if (this.isMini) {
      this.logo = "logo-extrasmall.png";
    }
  },
  methods: {
    // action login => envoie vers l'identification CAS via le backend de l'application
    login() {
      window.location = this.loginUrl;
    },
    displayedArrow() {
      if (this.activeLink) return this.activeLink.meta.menu;
    },

    findActiveLinkPosition() {
      var position = -1;

      this.$router.options.routes.forEach((link, index) => {
        if (index <= this.activeLinkIndex) {
          if (this.getLinkVisibility(link.meta)) {
            position++;
          }
        }
      });
      return position;
    },
    findActiveLink() {
      this.$router.options.routes.forEach((link, index) => {
        if (link.name == this.$route.name) {
          this.activeLinkIndex = index;
          this.activeLink = link;
        }
      });
    },
    getLogoUrl(logoName) {
      return require("@/assets/" + logoName);
    },
    getLinkVisibility(linkMetas) {
      if (!linkMetas.menu) {
        return false;
      } else {
        var linkVisibility = false;
        // aucune précison sur l'autorisation d'accès à cette route
        if (linkMetas.access === undefined) {
          linkVisibility = true;
        }
        // route publique (toujours autorisée)
        else if (linkMetas.access.type === "public") {
          linkVisibility = true;
        }
        // route accessible uniquement aux utilisateurs non-authentifiés
        else if (linkMetas.access.type === "anonymous") {
          // si l'utilisateur a accès et n'est pas authentifié
          if (!this.isAuthenticated) {
            linkVisibility = true;
          }
        }
        // route accessible uniquement aux utilisateurs authentifiés
        else if (linkMetas.access.type === "authenticated") {
          // si l'utilisateur est authentifié
          if (this.isAuthenticated) {
            linkVisibility = true;
            // pour chaque rôle de l'utilisateur,
            // on teste sa présence dans la liste des rôles autorisés à accéder à cette route
            if (Array.isArray(linkMetas.access.roles)) {
              linkVisibility = false;
              if (Array.isArray(this.user.roles)) {
                this.user.roles.forEach(userRole => {
                  if (linkMetas.access.roles.indexOf(userRole) > -1) {
                    linkVisibility = true;
                  }
                });
              }
            }
          }
        }
        return linkVisibility;
      }
    }
  }
};
</script>

<style scoped>
.v-application a.v-list-item--active {
  color: #ffffff;
}
.v-list-item__title {
  font-size: 0.9em;
}

div.moving-arrow.v-card {
  box-shadow: none;
  background-color: transparent;
  border-top: 17px solid transparent;
  border-bottom: 17px solid transparent;
  display: inline-block;
  position: absolute;
  left: 284px;
  top: 15px;
  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1);
  z-index: 1;
}

.v-application.theme--light div.moving-arrow.v-card {
  border-right: 17px solid #ededed !important;
}

.v-application.theme--dark div.moving-arrow.v-card {
  border-right: 17px solid #121212 !important;
}
div.link-donneesPersonnelles a {
  color: #ccc;
}
</style>
